import { useContext } from "react";
import { UserContext } from "../../../contexts/user";
import Unauthorised from "../../../pages/error/401";

const Page = ({children, permission}) => { 

    const { hasRolePermission } = useContext(UserContext);

    const hasPermission = !permission ? true : hasRolePermission(permission);

    if (typeof(hasPermission) === 'undefined') return <></>;

    if (!hasPermission) { 
        return <Unauthorised />
    }

    return children;

}

export default Page;